import React from 'react';
import type { RouteProp } from '@react-navigation/native';
import { useRoute } from '@react-navigation/native';
import type { AddressType } from '@sg/garnish';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { ConfirmLocation } from '../../../../components/ConfirmLocation';
import type { ModalStackParamList } from '../../../../navigation/AppNavigation.props';
import { OrderProductGuard } from '../../components/OrderProductGuard';
import { useNavigateToBaseProductDetail } from '../../hooks/useNavigateToBaseProductDetails';
import { useOrderProductConfirmLocationScreenData } from './hooks/useOrderProductConfirmLocationScreenData';

export const OrderProductConfirmLocationScreen = () => {
  const {
    params: { productSlug },
  } = useRoute<RouteProp<ModalStackParamList, 'OrderProductConfirmLocation'>>();

  // FIXME - These will be updated to use the actual values in MNU-500.
  const addressId = '28512';
  const orderType = 'delivery' as AddressType;

  const { region, restaurant, deliveryAddress, pins, isFetching } =
    useOrderProductConfirmLocationScreenData({
      restaurantSlug: 'century-city',
      addressId,
    });

  const isContinueButtonEnabled = useFeatureFlag(
    'MNU-656-deeplink-continue-button-enabled',
    {
      listenForChanges: true,
    },
  );

  const navigateToProductDetail = useNavigateToBaseProductDetail({
    baseProductSlug: productSlug,
    restaurantId: restaurant?.id ?? '',
    restaurantSlug: restaurant?.slug,
    deliveryAddressId: deliveryAddress?.id,
    isContinueButtonEnabled,
  });

  return (
    <OrderProductGuard>
      <ConfirmLocation
        deliveryAddress={deliveryAddress}
        isFetching={isFetching}
        orderType={orderType}
        restaurant={restaurant}
        region={region}
        pins={pins}
        isLoading={false}
        onContinue={navigateToProductDetail}
        onMoreLocations={() => {}}
        hasError={!region || !restaurant}
      />
    </OrderProductGuard>
  );
};
